import { createFileRoute } from '@tanstack/react-router';

import { ReferencePage } from '../../pages/reference';

export const Route = createFileRoute('/_shell/reference')({ component: ReferencePage });
